import { render, staticRenderFns } from "./DetailAppleDeveloperProgramForm.vue?vue&type=template&id=5fd6fb0e&scoped=true&"
import script from "./DetailAppleDeveloperProgramForm.vue?vue&type=script&lang=ts&"
export * from "./DetailAppleDeveloperProgramForm.vue?vue&type=script&lang=ts&"
import style0 from "./DetailAppleDeveloperProgramForm.vue?vue&type=style&index=0&id=5fd6fb0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd6fb0e",
  null
  
)

export default component.exports